import { NotificationName } from 'utils/constants/notification';

import { setCrmActivityOwners } from 'store/models/crmActivity';
import { addNotification } from 'store/models/notification';

export default (ownerId) => {
    return (dispatch, getState) => {
        const { owners } = getState().crmActivity;
        if (owners.length < 2) {
            dispatch(addNotification(NotificationName.CrmUpdateAlert));
            return;
        }
        const newOwners = owners.slice().filter(({ id }) => ownerId !== id);
        dispatch(setCrmActivityOwners(newOwners));
    };
};
